import { render } from "./AdminConfigurationEdit.vue?vue&type=template&id=5fd76cfa&scoped=true&ts=true&lang=true"
import script from "./AdminConfigurationEdit.vue?vue&type=script&lang=ts"
export * from "./AdminConfigurationEdit.vue?vue&type=script&lang=ts"

import "./AdminConfigurationEdit.vue?vue&type=style&index=0&id=5fd76cfa&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fd76cfa"]])

export default __exports__